import React, {Component} from 'react';
import axios from 'axios';
import ReactHowler from 'react-howler'
import { Howler } from 'howler';
import {_sort, _parseMp3ToOpus, _parseOpusToMp3} from "../../asset/js/myFunctions";

//Process.env.PUBLIC_URL === ""

let mTimeout = null;
let tempAudio = null;

const getPrimaryAudioSrc = (src) => {
    if (!src) return src;
    return _parseMp3ToOpus(src);
};

const getFallbackAudioSrc = (src) => {
    if (!src) return src;
    return /\.opus(?=($|[?#]))/i.test(src) ? _parseOpusToMp3(src) : src;
};

const withContents = () => (WrappedComponent) => {
    return class extends Component {
        state = {
            contents: null,
            playingIndex: 0,
            audioList: [],
            isPlaying: false,
            isPlayingComplete: false,
            isAllPlayingComplete: false,
            hasErrorOnLoad:false,
            hasErrorOnPlay:false,
            c_code: null,
            playingAudioURL: null,
            loadCount:0,
            playing:false,
            audioSrc:null,
            mp3Src:null,
            callback:null,
            errorCallback:null,
            volume:1,
            tryOpus:true,
        };



        componentDidMount() {
            //console.log("헬로우");
            this.initialize();
            this.mounted = true;

        }


        componentWillUnmount() {
            //this._audioStop();
            clearTimeout(mTimeout);
            mTimeout = null;
            this.mounted = false;
        }

        componentDidUpdate(prevProps, prevState) {
            if (prevState.c_code !== this.state.c_code) {
                this.setState({
                    contents: null,
                    isAllPlayingComplete: false,
                });
                this.initialize();
            }
            //console.log(this.state.playing);
        }

        static getDerivedStateFromProps(nextProps, prevState) {

            if (nextProps.c_code !== prevState.c_code) {
                //console.log("nextProps.c_code :", nextProps.c_code);
                //console.log("prevState.c_code :", prevState.c_code);

                return ({
                    c_code: nextProps.c_code
                })
            }

            return null;
        }


        initialize() {
            Promise.all([
                axios({
                    method: 'get',
                    url: `${this.props.apiUrl}/contents/${this.props.lessonInfo.step_code}/${this.props.lessonInfo.lesson_no}/${this.state.c_code}`.replace(/\s/g, ''),
                })
            ])
                .then(([resContents]) => {
                    // //console.log("component will mount contents is:", res);
                    let contents = resContents.data;
                    //console.log("API에서 받아온 CONTENTS:", contents);
                    if(this.mounted) {
                        this.setState({
                            ...this.state,
                            contents: _sort(contents),
                            //menuList,
                        });
                    }

                })
                .catch(function (err) {
                    console.log(err);
                })
                .then(function () {
                });
        };


        resumeCtx = () => {
            this.player.howler.ctx.resume();
        }


        handleOnLoadError = (err) => {     
            // opus 재생 실패 시, mp3로 재생 시도
            if (this.state.tryOpus) {                
                let mp3Src = this.state.mp3Src;
                // console.log("mp3로 재생 시도", mp3Src);
                this.setState({
                    tryOpus: false,
                    audioSrc:mp3Src,                    
                    playing:true,
                    isPlaying:true,
                })
                return;
            }
                
            if(typeof this.state.errorCallback === "function") {
                this.state.errorCallback();
            } else {
                console.log("on load error: ",err);
                this.setSrc(null);
            }
        }

        setSrc = (src) => {
            console.log("set audio Source",src);            
            this.setState({
                audioSrc:src,
                mp3Src:src,
                playing:false,
                isPlaying:false,
            })
        }

        setHowler = (src, callback) => {
            let primarySrc = getPrimaryAudioSrc(src);
            let fallbackSrc = getFallbackAudioSrc(src);
            console.log("set howler Source",primarySrc);
            // console.log(Howler.codecs('opus'));

            this.setState({                
                audioSrc:primarySrc,
                mp3Src:fallbackSrc,
                tryOpus:true,
                playing:true,
                isPlaying:true,
                volume:1,
                callback,
                errorCallback:null,
            })
        }

        setHowlerError = (src, callback, errorCallback) => {
            let primarySrc = getPrimaryAudioSrc(src);
            let fallbackSrc = getFallbackAudioSrc(src);
            console.log("set howler Error Source",primarySrc);
            
            this.setState({
                audioSrc:primarySrc,
                mp3Src:fallbackSrc,
                tryOpus:true,
                playing:true,
                isPlaying:true,
                volume:1,
                callback,
                errorCallback,
            })
        }

        setHowlerMute = (src, callback) => {
            let primarySrc = getPrimaryAudioSrc(src);
            let fallbackSrc = getFallbackAudioSrc(src);
            console.log("set howler Mute Source",primarySrc);
            
            this.setState({
                audioSrc:primarySrc,
                mp3Src:fallbackSrc,
                tryOpus:true,
                playing:true,
                isPlaying:true,
                volume:0,
                callback,
                errorCallback:null,
            })
        }
        
        audioStop = () => {
            this.setState({
                playing:false,
                isPlaying:false,
            })
        }

        render() {
            const {contents} = this.state;
            return (
                <>
                    {
                        (this.state.audioSrc && this.state.playing) &&
                        <ReactHowler
                            preload={true}
                            playing={this.state.playing}
                            src={`${this.props.soundRootURL}/${this.state.audioSrc}`}
                            onLoadError={this.handleOnLoadError}
                            html5={true}
                            format={['opus', 'mp3']}
                            volume={this.state.volume}
                            onEnd={() => {
                                console.log("end");
                                this.setState({
                                    playing:false,
                                    isPlaying:false,
                                })
                                if(typeof this.state.callback === "function") {

                                    this.state.callback();

                                }
                            }
                            }
                            // onEnd={() => console.log("end")}
                            ref={(ref) => (this.player = ref)}
                        />
                    }
                    <WrappedComponent {...this.props}
                                      contents={contents}
                                      setHowler={this.setHowler}
                                      setHowlerMute={this.setHowlerMute}
                                      setHowlerError={this.setHowlerError}
                                      setSrc={this.setSrc}
                                      audioStop={this.audioStop}
                                      // audioPause={this._audioPause.bind(this)}
                                      // audioStop={this._audioStop.bind(this)}
                                      // audioPlay={this._audioPlay.bind(this)}
                                      // audioPlayWithURL={this._audioPlayWithURL.bind(this)}
                                      // audioPlayWithCb={this._audioPlayWithCb.bind(this)}
                                      // audioPlayMute={this._audioPlayMute.bind(this)}
                                      // audioFakePlay={this._audioFakePlay.bind(this)}
                                      // audioPlayAll={this._audioPlayAll.bind(this)}
                                      // audioPlayTill={this._audioPlayTill.bind(this)}
                                      // audioPlayPart={this._audioPlayPart.bind(this)}
                                      // audioPlayRange={this._audioPlayRange.bind(this)}
                                      playingIndex={this.state.playingIndex}
                                      isPlaying={this.state.isPlaying}
                                      // isPlayingComplete={this.state.isPlayingComplete}
                                      // isAllPlayingComplete={this.state.isAllPlayingComplete}
                                      hasErrorOnLoad={this.state.hasErrorOnLoad}
                                      hasErrorOnPlay={this.state.hasErrorOnPlay}
                    />
                </>

            )
        }
    }


};

export default withContents;
